import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import {
  SearchCadastroParams,
  SearchCadastroResponse,
  UpdateCadastroParams,
} from "../types";

export const documentEditService = {
  async searchCadastro(
    params: SearchCadastroParams
  ): Promise<ApiResponse<SearchCadastroResponse>> {
    return apiClient.post("/gestorCadastroDocView", params);
  },

  async updateCadastro(
    params: UpdateCadastroParams
  ): Promise<ApiResponse<any>> {
    return apiClient.post("/gestorCadastroDocUpdate", params);
  },
};
